import { now } from "../firebase";

export default class Projects {
  db: firebase.firestore.Firestore;
  collection: firebase.firestore.CollectionReference;

  constructor(db: firebase.firestore.Firestore, uid: string) {
    this.db = db;
    this.collection = db
      .collection("users")
      .doc(uid)
      .collection("projects");
  }

  all(): Promise<any[]> {
    return this.collection
      .orderBy("created")
      .get()
      .then(function(querySnapshot: any) {
        let executions: any[] = [];
        querySnapshot.forEach(function(doc: any) {
          executions.push({ id: doc.id, ...doc.data() });
        });
        return executions;
      });
  }

  create(attrs: any): Promise<any> {
    attrs = { ...attrs, created: now() };
    return this.collection.add(attrs).then(function(doc: any) {
      return { id: doc.id, ...attrs };
    });
  }

  delete(id: any): void {
    this.collection.doc(id).delete();
  }

  update(id: any, attrs: any): Promise<any> {
    return this.collection
      .doc(id)
      .set(attrs)
      .then(() => ({ id: id, ...attrs }));
  }
}
